export const hasDomElement = (selector: string) => {
    return !!getDOMElement(selector);
};
export const getDOMElement = (selector: string) => {
    return !!selector ? document.querySelector(selector) : null;
};
